module.exports = __webpack_public_path__ + "static/img/avatar.fc31d8d8.png";